// extracted by mini-css-extract-plugin
export default {"example":"ExampleImage_example__lb-nA"};